import { Directive, forwardRef, Inject } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { RoleService } from '../core/role.service';

@Directive({
  selector: '[appExistsRoleName][ngModel],[appExistsRoleName][formControl]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, multi: true,
    useExisting: forwardRef(() => ExistsRoleNameValidator),
  }],
})
export class ExistsRoleNameValidator implements AsyncValidator {

  constructor(
    private roleService: RoleService
  ) {
  }
  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return this.roleService.checkNameNotTaken(control.value).map(exists => {
        return exists ? {'nameExists': true} : null;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/exists-role-name.validator.ts